export const handleError = (error: Error, context: string) => {
  if (error.name === 'AbortError') {
    console.log('Request was aborted');
  } else {
    console.error(`Error in ${context} in onQueryStarted:`, error);
  }
};

export const handleQueryLifecycle = async <T>(
  queryFulfilled: Promise<{ data: T }>,
  context: string,
  onSuccess?: (data: T) => void,
) => {
  try {
    const { data } = await queryFulfilled;

    if (data && onSuccess) {
      onSuccess(data);
    }
  } catch (error) {
    handleError(error as Error, context);
  }
};
